<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BFormInput
            id="filterSearch"
            v-model="tableAreaManagers.filter.search"
            placeholder="search here"
            autocomplete="off"
            debounce="1000"
            type="text"
          />
        </BFormGroup>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableAreaManagers"
      :provider="tableProvider"
      :fields="tableAreaManagers.fields"
      :filter="tableAreaManagers.filter"
      :filter-on="tableAreaManagers.filterOn"
      :sort-by="tableAreaManagers.sortBy"
      :sort-desc="tableAreaManagers.sortDesc"
      :sort-direction="tableAreaManagers.sortDirection"
      :total-rows="tableAreaManagers.totalRows"
      :current-page="tableAreaManagers.currentPage"
      :per-page="tableAreaManagers.perPage"
      :stacked="tableAreaManagers.stacked"
      :busy="tableAreaManagers.busy"
    >
      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center gap-2">
          <!-- <BButton
            size="sm"
            variant="primary"
            :to="{
              name: 'asm.officers.profile',
              params: {
                officer: item.id
              }
            }"
          >
            View
          </BButton> -->
          <BButton
            size="sm"
            variant="primary"
            :to="{
              name: 'asm.officers.tasks',
              params: {
                officer: item.id
              }
            }"
          >
            Tasks
          </BButton>
        </div>
      </template>

    </CustomTable>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { SRSMAsm } from '@/services/rsm'

export default {

  name: 'RSMAreaManagerUsers',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth',
    'rsm'
  ],

  metaInfo: () => ({
    title: 'AreaManagers'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      formAreaManager: {
        id: null,
        role_id: null,
        username: null,
        first_name: null,
        last_name: null,
        email: null,
        notification_email: null,
        mobile_number: null,
        clusters: []
      },
      tableAreaManagers: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          // { mobile: 4, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'name', label: 'Name', class: 'min-w-md-350px', formatter: this.getFullName, sortable: true },
          { mobile: 2, key: 'area.area_name', label: 'Area', class: 'min-w-150px', sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  }),

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableAreaManagers.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        team_id: this.currentUser.team
      }

      return await SRSMAsm.get(payload).then(
        ({ data }) => {
          this.tableAreaManagers.totalRows = data.total_rows
          return data.items
        }
      ).catch(() => {
        this.tableAreaManagers.totalRows = 0
        return []
      }).finally(() => {
        this.tableAreaManagers.busy = false
      })
    }
  }
}
</script>
